<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section aria-labelledby="ack" epub:type="acknowledgments" role="doc-acknowledgments">
<header>
<p class="SP"> </p>
<h1 class="FM-Head-fmh"><span aria-label="vii" id="pg_vii" role="doc-pagebreak"><span href="#/xhtml/contents#c_ack" id="ack" title="Link target outside of Sample"><b>ACKNOWLEDGMENTS</b></span></span></h1>
</header>
<p class="Chap-Opening-Text-No-Indent-cotx1">Thanks to: Louise Maker, Mark Duncan, Marina Hardiman, Annalisa Ferrarotto, Stephen Coates, Nicola Stewart, Jonathan Field, Vicky Hutchinson, Peter Sollett, Eva Vives, Mike Loteryman, Anna Baker-Jones, Alice Naylor, Susanna Moore, Charles Spicer, and Deborah Schneider.</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?0616207a